import { motion } from "framer-motion";
import { useLang } from "../i18n";

const rise = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.19, 1, 0.22, 1] } },
};

export const Manifesto = () => {
  const { t } = useLang();
  const imgs = [
    "/images/jysl2odv_4.webp",
    "/images/nzczn99e_3.webp",
    "/images/s5irdh3h_31.webp",
    "/images/834c1d417601e6137ce5d9eec8cd1b2bbfa4c0cd99b57646ae87c7d0a3b1.webp",
  ];

  return (
    <section id="villa" className="px-6 md:px-12 py-24 md:py-36 max-w-[1600px] mx-auto" data-testid="villa-section">
      <motion.div
        variants={rise}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-100px" }}
        className="max-w-3xl mb-20 md:mb-28"
      >
        <span className="text-[11px] tracking-[0.35em] uppercase text-terracotta">{t.manifesto.eyebrow}</span>
        <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.05] mt-4 tracking-tight">
          {t.manifesto.titleA} <span className="italic">{t.manifesto.titleB}</span>
        </h2>
        <div className="mt-8 space-y-5">
          {t.manifesto.intro.map((p, i) => (
            <p key={i} className="text-ink-soft text-base md:text-lg font-light leading-relaxed">{p}</p>
          ))}
        </div>
      </motion.div>

      <div className="space-y-24 md:space-y-40">
        {t.manifesto.chapters.map((c, i) => (
          <div
            key={c.num}
            id={i === 0 ? "villa-chapitre" : undefined}
            className={`grid md:grid-cols-12 gap-8 md:gap-16 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
          >
            <motion.div
              variants={rise}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-120px" }}
              className="md:col-span-7 [direction:ltr]"
            >
              <div className="overflow-hidden">
                <motion.img
                  initial={{ scale: 1.25 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, ease: [0.19, 1, 0.22, 1] }}
                  src={imgs[i]}
                  alt={c.title}
                  className="w-full aspect-video h-auto md:aspect-auto md:h-[76vh] object-cover"
                />
              </div>
            </motion.div>

            <motion.div
              variants={rise}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-120px" }}
              className="md:col-span-5 [direction:ltr]"
            >
              <div className="flex items-baseline gap-4 mb-5">
                <span className="font-serif text-2xl text-terracotta">{c.num}</span>
                <span className="h-[1px] flex-1 bg-[var(--line)]" />
              </div>
              <h3 className="font-serif font-light text-3xl md:text-5xl mb-6 tracking-tight">{c.title}</h3>
              <p className="text-ink-soft text-base md:text-lg font-light leading-relaxed max-w-md whitespace-pre-line">{c.body}</p>
            </motion.div>
          </div>
        ))}
      </div>

      <motion.div
        variants={rise}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-100px" }}
        className="mt-24 md:mt-36 max-w-3xl mx-auto text-center"
        data-testid="manifesto-quote"
      >
        <p className="font-serif font-light italic text-2xl md:text-4xl leading-snug tracking-tight text-ink">
          {t.manifesto.quote}
        </p>
        <p className="mt-6 text-terracotta text-[11px] tracking-[0.3em] uppercase">{t.manifesto.quoteSub}</p>
      </motion.div>
    </section>
  );
};
